module.exports = __webpack_public_path__ + "static/media/sk.b84444bf.svg";